import { createContext, useContext } from 'react'
import type {
  WorkspacePulseEvent,
  WorkspacePulseSnapshot,
} from '../services/aiAgentBridge'
import type { PulseReport, PulseReportKind } from '../types/pulseReport'

export const emptyPulseSnapshot = (workspaceId: string, walletCredits: number): WorkspacePulseSnapshot => ({
  workspaceId,
  healthState: 'HEALTHY',
  riskScore: 0,
  openRiskCount: 0,
  failedAutomationCount: 0,
  stockShortageCount: 0,
  walletCredits,
  budget: { totalBudgetLimit: 0, totalActualSpend: 0, utilization: 0, overBudgetCount: 0 },
  activity: { last24hCount: 0, latest: [] },
  topRisks: [],
})

export type MemberPulseContextValue = {
  pulse: WorkspacePulseSnapshot
  reports: PulseReport[]
  events: WorkspacePulseEvent[]
  error: string | null
  reportsUnavailable: boolean
  refreshPulse: () => void
  setError: (error: string | null) => void
  pinReport: (reportId: string, pinned: boolean) => Promise<void>
  deleteReport: (reportId: string) => Promise<void>
  runReport: (kind: PulseReportKind) => Promise<{ reportId?: string; cached?: boolean; creditsCharged?: number }>
}

export const MemberPulseContext = createContext<MemberPulseContextValue | null>(null)

export const useMemberPulse = (): MemberPulseContextValue => {
  const context = useContext(MemberPulseContext)
  if (!context) {
    throw new Error('useMemberPulse must be used within a MemberPulseProvider')
  }
  return context
}
